import {
  CREATE_CASE_SET_BACKEND_ERRORS,
  CREATE_CASE_SET_PROGRESS,
  CCCO_FILL_MATERIALS_FORM
} from './available';

export default {
  [CREATE_CASE_SET_BACKEND_ERRORS] (state, errorMessagesByFields) {
    state.createCase.form.errorMessages = errorMessagesByFields
  },
  [CREATE_CASE_SET_PROGRESS] (state, {action, value}) {
    state.createCase = {
      ...state.createCase,
      progress: value,
      progressByActions: {
        ...state.createCase.progressByActions,
        [action]: value
      }
    }
  },
  [CCCO_FILL_MATERIALS_FORM] (state, materialsForm) {
    state.createCase = {
      ...state.createCase,
      materialsFormValue: materialsForm
    }
  }
}
